.navbar-type-1 {
  position: relative;
  width: 100%;
  z-index: 100;
  background-color: var(--color-neutral-white);

  // Note: .navbar-type-1--sticky class is still set in render() but has no styles.
  // Sticky positioning moved to the HOST element (navbar-type-1 custom element)
  // via .is-sticky-host class. See componentDidLoad() and the bottom of this file.

  &--with-border {
    border-bottom: 1px solid var(--color-neutral-black);
  }

  &--mobile-full-width {
    .navbar-type-1__container--mobile {
      width: 100%;
    }
  }

  &.is-fixed {
    box-shadow: 0 4px 12px rgb(44 44 44 / 12%);
  }

  &__container {
    display: flex;

    @include container;

    padding-top: calc(var(--spacing-md) - 2px);
    padding-bottom: calc(var(--spacing-md) - 2px);

    @include above($breakpoint-desktop-md) {
      padding-top: 0;
      padding-bottom: 0;
    }

    &--desktop {
      z-index: 100;
      align-items: center;
      justify-content: space-between;

      .me-button {
        white-space: nowrap;
      }

      .navbar-type-1__nav-column {
        .me-button {
          margin: calc(var(--spacing-xl) + 4px) 0;
        }

        .me-dropdown__menu {
          .me-button {
            margin: 0;
            text-align: left;
          }
        }
      }
    }

    &--mobile {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 90%;
      background-color: var(--color-neutral-white);
      z-index: 99;
      overflow-y: auto;
      transform: translateX(-100%);
      visibility: hidden;
      opacity: 0;
      transition:
        transform 0.3s ease-in-out,
        opacity 0.25s ease-in-out,
        visibility 0s linear 0.3s;
      padding: 0;
      align-items: flex-start;
      touch-action: pan-y;

      @include container;

      &.is-open {
        transform: translateX(0);
        visibility: visible;
        opacity: 1;
        transition:
          transform 0.3s ease-in-out,
          opacity 0.25s ease-in-out,
          visibility 0s linear 0s;
      }

      .navbar-type-1__mobile-content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-xl);
      }
    }
  }

  &__column {
    display: flex;
  }

  &__nav-column {
    display: flex;
    gap: var(--spacing-2xl);
  }

  &__actions-column {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);

    @include desktop {
      gap: var(--spacing-md);
    }
  }

  &--default {
    .navbar-type-1__logo-column {
      order: 1;
      margin-right: auto;
    }

    .navbar-type-1__nav-column {
      order: 2;
      flex-grow: 0;
      justify-content: flex-end;
      margin-right: 0;
    }

    .navbar-type-1__actions-column {
      display: flex;
      order: 3;
      margin-left: var(--spacing-2xl);
    }

    .navbar-type-1__mobile-toggle {
      display: none;
    }

    // Mobile styles (below 768px)
    @include below-desktop {
      .navbar-type-1__nav-column {
        display: none;
      }

      .navbar-type-1__actions-column {
        display: none;
      }

      .navbar-type-1__mobile-toggle {
        display: flex;
        order: 3;
      }
    }

    // Dynamic mobile view control (based on mobileBreakpoint prop)
    &.is-mobile-view {
      .navbar-type-1__nav-column {
        display: none;
      }

      .navbar-type-1__actions-column {
        display: none;
      }

      .navbar-type-1__mobile-toggle {
        display: flex;
        order: 3;
      }
    }
  }

  &--centered {
    .navbar-type-1__logo-column {
      order: 1;
    }

    .navbar-type-1__nav-column {
      order: 2;
      flex-grow: 1;
      justify-content: center;
    }

    .navbar-type-1__actions-column {
      display: flex;
      order: 3;
    }

    .navbar-type-1__mobile-toggle {
      display: none;
    }

    // Mobile styles (below 768px)
    @include below-desktop {
      .navbar-type-1__nav-column {
        display: none;
      }

      .navbar-type-1__actions-column {
        display: none;
      }

      .navbar-type-1__mobile-toggle {
        display: flex;
        order: 3;
      }
    }

    // Dynamic mobile view control (based on mobileBreakpoint prop)
    &.is-mobile-view {
      .navbar-type-1__nav-column {
        display: none;
      }

      .navbar-type-1__actions-column {
        display: none;
      }

      .navbar-type-1__mobile-toggle {
        display: flex;
        order: 3;
      }
    }
  }

  &--nav-first {
    .navbar-type-1__logo-column {
      order: 2;
      flex-grow: 1;
      justify-content: center;
    }

    .navbar-type-1__nav-column {
      order: 1;
    }

    .navbar-type-1__actions-column {
      display: flex;
      order: 3;
    }

    .navbar-type-1__mobile-toggle {
      display: none;
    }

    // Mobile styles (below 768px)
    @include below-desktop {
      .navbar-type-1__nav-column {
        display: none;
      }

      .navbar-type-1__actions-column {
        me-button {
          &:first-child {
            display: none;
          }
        }
      }

      .navbar-type-1__mobile-toggle {
        display: flex;
        order: 3;
      }
    }

    // Dynamic mobile view control (based on mobileBreakpoint prop)
    &.is-mobile-view {
      .navbar-type-1__nav-column {
        display: none;
      }

      .navbar-type-1__actions-column {
        me-button {
          &:first-child {
            display: none;
          }
        }
      }

      .navbar-type-1__mobile-toggle {
        display: flex;
        order: 3;
      }
    }
  }

  &--logo-nav-first {
    .navbar-type-1__logo-column {
      order: 1;
      margin-right: var(--spacing-2xl);
    }

    .navbar-type-1__nav-column {
      display: flex;
      order: 2;
      flex-grow: 0;
      justify-content: flex-start;
      margin-left: 0;
      margin-right: auto;
    }

    .navbar-type-1__actions-column {
      display: flex;
      order: 3;
    }

    .navbar-type-1__mobile-toggle {
      display: none;
    }

    // Mobile styles (below 768px)
    @include below-desktop {
      .navbar-type-1__nav-column {
        display: none;
      }

      .navbar-type-1__actions-column {
        display: none;
      }

      .navbar-type-1__mobile-toggle {
        display: flex;
        order: 3;
      }
    }

    // Dynamic mobile view control (based on mobileBreakpoint prop)
    &.is-mobile-view {
      .navbar-type-1__nav-column {
        display: none;
      }

      .navbar-type-1__actions-column {
        display: none;
      }

      .navbar-type-1__mobile-toggle {
        display: flex;
        order: 3;
      }
    }
  }

  &__mobile-toggle {
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    padding: var(--spacing-2xs);
    margin-left: auto;

    @include size(24px, 22px);

    position: relative;
    z-index: 102;

    &:focus {
      outline: 2px solid var(--color-brand-primary-main);
      border-radius: var(--radius-size-sm);
    }

    &__line {
      display: block;
      width: 100%;
      height: 2px;
      background-color: var(--text-color-primary);
      border-radius: var(--radius-size-sm);
      transition: all 0.3s ease;
    }

    &.is-active {
      .navbar-type-1__mobile-toggle__line {
        &:nth-child(1) {
          transform: translateY(6px) rotate(45deg);
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:nth-child(3) {
          transform: translateY(-6px) rotate(-45deg);
        }
      }
    }
  }

  &__mobile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-md);
    min-height: 20px;
  }

  &__mobile-content {
    width: 100%;

    // Reserve space at the bottom so expanded dropdown content
    // can be fully scrolled into view on mobile.
    padding-bottom: 80px;
    padding-bottom: calc(80px + env(safe-area-inset-bottom));

    .me-dropdown {
      display: block;
      width: 100%;
    }
  }

  &__mobile-actions {
    margin-top: var(--spacing-md);
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);

    .me-button {
      width: 100%;
    }
  }

  &--dark {
    background-color: var(--color-neutral-neutral-darker);
    color: var(--color-neutral-white);

    .navbar-type-1__mobile-toggle {
      &__line {
        background-color: var(--color-neutral-white);
      }
    }

    .navbar-type-1__container--mobile {
      background-color: var(--color-neutral-neutral-darker);
    }

    .navbar-type-1__mobile-header {
      border-bottom-color: var(--color-neutral-neutral);
    }

    .navbar-type-1__mobile-content {
      .me-nav-link {
        border-bottom-color: var(--color-neutral-neutral);
        color: var(--color-neutral-white);
      }
    }

    .navbar-type-1__mobile-actions {
      border-top-color: var(--color-neutral-neutral);
    }
  }

  .me-button--ghost {
    font-weight: 400;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

@include below-desktop {
  body:has(.navbar-type-1__container--mobile.is-open)::before {
    content: '';
    position: fixed;
    inset: 0;
    background-color: rgba(var(--color-neutral-black), 0.5);
    z-index: 90;
    transition: opacity 0.25s ease-in-out;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    cursor: pointer;
  }
}

// Dynamic mobile view overlay
body:has(.navbar-type-1.is-mobile-view .navbar-type-1__container--mobile.is-open)::before {
  content: '';
  position: fixed;
  inset: 0;
  background-color: rgba(var(--color-neutral-black), 0.5);
  z-index: 90;
  transition: opacity 0.25s ease-in-out;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  cursor: pointer;
}

// =============================================================================
// Host element (navbar-type-1 custom element) sticky positioning.
// =============================================================================
// Custom elements default to display: inline which doesn't support sticky.
// Block display ensures proper box model for sticky positioning.
navbar-type-1 {
  display: block;
}

// Sticky positioning on the host element. Applied via JS when the sticky prop
// is truthy. This prevents the "tight wrapper" problem: an inner <header> with
// position: sticky inside a host element of the same height has no room to
// stick, so sticky must be on the outermost wrapper.
navbar-type-1.is-sticky-host {
  position: sticky;
  top: 0;
  z-index: 100;

  // Transition for hide-on-scroll mode (host's top is animated via JS).
  transition: top 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}
